import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormRow } from './FormRow';

var FormBuilder = function FormBuilder(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.rows.map(function (row, index) {
    return /*#__PURE__*/React.createElement(FormRow, _extends({
      key: index,
      row: row
    }, props));
  }));
};

export { FormBuilder };